<style lang="scss">
.hamburger-button {
    display: flex;
    height: 64px;
    justify-content: center;
    cursor: pointer;

    .button-icon {
        width: 20px;
        height: 14px;
        overflow: hidden;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        margin: auto 8px auto 8px;
        transition: height 0.3s, transform 0.4s;
        z-index: 200;

        span {
            color: #fff;
            height: 2px;
            border-radius: 1px;
            width: 100%;
            background: #fff;
            display: flex;
            transition: all 0.3s;
            transform-origin: left;
            align-self: flex-end;
        }

        &.active {
            height: 16px;
            span {
                background: #fff;

                &:nth-child(1) {
                    transform: translateX(2px) rotate(45deg);
                }
                &:nth-child(2) {
                    opacity: 0;
                }
                &:nth-child(3) {
                    transform: translateX(2px) rotate(-45deg);
                }
            }
        }
    }

    &:hover {
        .button-icon {
            &:not(.active) {
                span {
                    &:nth-child(1) {
                        transform: translateX(-4px);
                    }
                    &:nth-child(2) {
                        transform: translateX(4px);
                    }
                    &:nth-child(3) {
                        transform: translateX(-4px);
                    }
                }
            }
        }
    }
}

/**
 * No transition when resizing browser window
 */
body.resizing {
    .button-icon {
        transition: none !important;
        span {
            transition: none !important;
        }
    }
}
</style>

<template>
    <div class="hamburger-button" @click="toggleMenu">
        <div class="button-icon" :class="{'active': isActive}">
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        toggleMenu() {
            this.$root.mobileSearchIsVisible = false;
            this.$root.navigationIsVisble = !this.$root.navigationIsVisble;
        }
    },

    computed: {
        isActive() {
            return this.$root.navigationIsVisble;
        }
    }
}
</script>